import CreatorRevenueTabComponent from "./CreatorRevenueTabComponent";

export default CreatorRevenueTabComponent;
